//actionDone函数
export const toggleMapDone=state=>{
    state.needShow = !state.needShow;
}
export const setLang=(state,lang)=>{
    state.lang=lang+'/';
}
export const setCur=(state,cur)=>{
    state.cur=cur;
}
